import { store } from 'react-easy-state'

export const state = store({
  modals: [],
  notifications: [],
  semaphore: 0,
  session: null,
})

export default state
